import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import 'rxjs/add/operator/map';


@Injectable()
export class KapitelProvider {

  _activeKapitel: string[];
  //_index:number = 0;

  lastPage: string = 'lastpage';


  constructor(public http: Http) {
    // console.log('Hello KapitelProvider Provider');
  }



  get getactiveKapitel(): string[] {

    return this._activeKapitel;

  }

  set setactiveKapitel(activeKapitel: string[]) {

    this._activeKapitel = activeKapitel;

  }

  get FirstPage(): string {

    return this._activeKapitel[0];

  }



  NextPage(thisPage: string): string {

    let i = this._activeKapitel.findIndex(x => x == thisPage)
    if (i == -1) {
      throw 'Konnte ' + thisPage + ' nicht in ' + this._activeKapitel + ' finden';
    }

    if (i == this._activeKapitel.length - 1) {
      return this.lastPage;
    }
    else {

      return this._activeKapitel[i + 1];
    }

  }

  isLastPage(thisPage: string): boolean {

    let i = this._activeKapitel.findIndex(x => x == thisPage)
    if (i == -1) {
      throw 'Konnte ' + thisPage + ' nicht in ' + this._activeKapitel + ' finden';
    }

    if (i == this._activeKapitel.length - 1) {
      return true;
    }

    return false;
  }


  Index(thisPage: string): number {

    let i = this._activeKapitel.findIndex(x => x == thisPage)
    if (i == -1) {
      throw 'Konnte ' + thisPage + ' nicht in ' + this._activeKapitel + ' finden';
    }

    return i;

  }

  //Kapitel################################################################################

  testkapitel(): string[] {

    let pages: string[] = [
      'AddiereSchriftlich0Bis9Page',
      'FindeSumme0Bis9Page',
      'TestpagePage'

    ];
    return pages;
  }

  zahlen0Bis9(): string[] {

    let pages: string[] = [
      'ZiffernUndZahlenPage',
      'Zahlen0Bis9Page',
      'ZaehleFinger0Bis9Page',
      'GeradeUndUngeradeZahlenPage',
      'WaehleGeradeUngerade0Bis9Page',
      'SortiereZahlenAufsteigend0Bis9Page',
      'SchreibeFehlendeZahlAufsteigend0Bis9Page',
      'SchreibeFehlendeZahlenAufsteigend0Bis9Page',
      //'SchreibeFehlende2ZahlenZufaelligeReihenfolgePage',//Todo mal schauen ob das beibehalten wird, zumindest keine Prioritat
      'Numerale0Bis9Page',
      'VerwandleTextInZahl0Bis9Page',
      'VerwandleZahlInText0Bis9Page',
      // 'SchreibeZahlen0Bis9Page'
    ];
    return pages;
  }

  addition0Bis9(): string[] {

    // temp.Add(typeof(Lektionen.Addition.DingeZusammenzählen));
    // temp.Add(typeof(Lektionen.Addition.ZahlenZusammenzählen));
    // temp.Add(typeof(Lektionen.Addition.Gleichheitszeichen));
    // temp.Add(typeof(Lektionen.Addition.RechenzeichenPlus));
    // temp.Add(typeof(Lektionen.Addition.Summanden));
    // temp.Add(typeof(Lektionen.Addition.Summenwert));
    // temp.Add(typeof(Lektionen.Addition.Vertauschungsgesetz));
    // temp.Add(typeof(Lektionen.Addition.NeutraleElementAddition));
    // temp.Add(typeof(Lektionen.Addition.SummenwertGrößteZahl));
    // temp.Add(typeof(Lektionen.Addition.RechenzeichenPlus));
    // temp.Add(typeof(Lektionen.Addition.RegelnAddition));
    // temp.Add(typeof(Lektionen.Addition.Zahlenbereich0Bis9.AlleAdditionen));
    // temp.Add(typeof(Lektionen.Addition.Zahlenbereich0Bis9.ÜbungFindeSumme));
    // temp.Add(typeof(Lektionen.Addition.Zahlenbereich0Bis9.ÜbungSchriftlicheAddition));
    // temp.Add(typeof(Lektionen.Addition.Zahlenbereich0Bis9.ÜbungAdditionKopfrechnen));



    let pages: string[] = [
      'DingeZusammenzaehlenPage',
      'ZahlenZusammenzaehlenPage',
      'GleichheitszeichenPage',
      'RechenzeichenPlusPage',
      'SummandenPage',
      'SummePage',
      'SummenwertPage',
      'BestandteileAdditionPage',
      'NeutraleElementAdditionPage',
      'SummenwertGroessteZahlPage',
      //'NurGleicheElementeAddierenPage', //todo nur gleiche elemente addieren mit Stellenwerte
      'VertauschungsgesetzPage',
      'RegelnAdditionPage',
      'AlleAdditionen0Bis9Page',
      'FindeSumme0Bis9Page',
      'AddiereSchriftlich0Bis9Page',
      'AddiereImKopf0Bis9Page'
    ];
    return pages;
  }

  abziehenBis9(): string[] {

    let pages: string[] = [
      'dummy'
    ];
    return pages;
  }

  zahlenBis9Vergleichen(): string[] {

    let pages: string[] = [
      'dummy'
    ];
    return pages;
  }

  eselbrueckeAdditionUmstellenBis9(): string[] {

    let pages: string[] = [
      'dummy'
    ];
    return pages;
  }

  eselbrueckeSubtraktionUmstellenBis9(): string[] {

    let pages: string[] = [
      'dummy'
    ];
    return pages;
  }

  alleDivisionen(): string[] {

    let pages: string[] = [
      'UmkehrungDivisionPage',
      'DivisorNicht0Page',
      'Divisor1NeutraleElementPage',
      'DivisionOhneRestPage',
      'DivisionMitRestPage',
      'DividentDivisorNichtVertauschenPage',
      'BestandteileDivisionPage',
      'Divisior10EinfachOhneRest0Bis100Page',
      'DividiereDivisior10EinfachOhneRest0Bis100Page',
      'Divisior10EinfachMitRest0Bis100Page',
      'DividiereDivisior10EinfachMitRest0Bis100Page',
      'TipDivisorBis9OhneRest0Bis999999Page',
      'DividiereDivisorBis9OhneRest0Bis999999Page',
      'DividendDivisorEinstelligOhneRest0Bis999999Page',
      'Divisor9OhneRest0Bis99Page',
      'Divisor8OhneRest0Bis99Page',
      'Divisor7OhneRest0Bis99Page',
      'Divisor6OhneRest0Bis99Page',
      'Divisor5OhneRest0Bis99Page',
      'Divisor4OhneRest0Bis99Page',
      'Divisor3OhneRest0Bis99Page',
      'Divisor2OhneRest0Bis99Page',
      'Divisor1OhneRest0Bis99Page',
      'DividiereOhneRest0Bis99Page',
      'DividiereDivisor9OhneRest0Bis99Page',
      'DividiereDivisor8OhneRest0Bis99Page',
      'DividiereDivisor7OhneRest0Bis99Page',
      'DividiereDivisor6OhneRest0Bis99Page',
      'DividiereDivisor5OhneRest0Bis99Page',
      'DividiereDivisor4OhneRest0Bis99Page',
      'DividiereDivisor3OhneRest0Bis99Page',
      'DividiereDivisor2OhneRest0Bis99Page',
      'DividiereDivisor1OhneRest0Bis99Page',
      'DividiereDivident0OhneRest0Bis99Page',
      'Dividiere0Bis9OhneRestPage',
      'Divident0OhneRest0Bis99Page',
      'Divisor9MitRest0Bis99Page',
      'Divisor8MitRest0Bis99Page',
      'Divisor7MitRest0Bis99Page',
      'Divisor6MitRest0Bis99Page',
      'Divisor5MitRest0Bis99Page',
      'Divisor4MitRest0Bis99Page',
      'Divisor3MitRest0Bis99Page',
      'Divisor2MitRest0Bis99Page',
      'Divisor1MitRest0Bis99Page',
      'DividiereDivisor9MitRest0Bis99Page',
      'DividiereDivisor8MitRest0Bis99Page',
      'DividiereDivisor7MitRest0Bis99Page',
      'DividiereDivisor6MitRest0Bis99Page',
      'DividiereDivisor5MitRest0Bis99Page',
      'DividiereDivisor4MitRest0Bis99Page',
      'DividiereDivisor3MitRest0Bis99Page',
      'DividiereDivisor2MitRest0Bis99Page',
      'DividiereDivisor1MitRest0Bis99Page',
      'DividiereDivident0MitRest0Bis99Page',
      'Dividiere0Bis9MitRestPage',
      'Divident0MitRest0Bis99Page',
      'TestpagePage'

    ];
    return pages;
  }

  alleSubtraktionen(): string[] {

    let pages: string[] = [
      'ZahlenAbziehenPage',
      'RegelnSubtraktionPage',
      'RechenzeichenMinusPage',
      'NeutraleElementPage',
      'MinuendSubtrahendNichtVertauschenPage',
      'MinuendSubtrahendPage',
      'MinuendGroessteZahlPage',
      'GleichheitszeichenPage',
      'DingeAbziehenPage',
      'DifferenzenwertPage',
      'DifferenzPage',
      'Zehneruebergang10Bis99Page',
      'SubtraktionZehnerEiner10Bis99Page',
      'SubtraktionVonZehnern10Bis99Page',
      'SubtraktionMitUebertrag10Bis99Page',
      'Subtraktion2StelligerZahlen10Bis99Page',
      'SubtrahiereZehneruebergang10Bis99Page',
      'SubtrahiereZehnerEinerOhneNotiz10Bis99Page',
      'SubtrahiereZehnerEiner10Bis99Page',
      'SubtrahiereVonZehnern10Bis99Page',
      'SubtrahiereMitUebertrag10Bis99Page',
      'SubtrahiereSchrittweisePage',
      'SubtrahiereOhneZehneruebergang10Bis19Page',
      'SubtrahiereMitChart10Bis19Page',
      'SubtrahiereBiszur10Page',
      'Subtrahiere10Bis19Page',
      'OhneZehneruebergang10Bis19Page',
      'MitZehneruebergang10Bis19Page',
      'Erste2StelligeZahl10Bis19Page',
      'AlleSubtraktionen10Bis19Page',
      'SubtrahiereMitChart0Bis9Page',
      'SubtrahiereImKopf0Bis9Page',
      'FindeDifferenz0Bis9Page',
      'AlleSubtraktionen0Bis9Page',
      'VertikalesSubtrahierenPage',
      'UebertragSubtrahendGroesserMinuend1000Bis999999Page',
      'UebertrageStellenwert1000Bis999999Page',
      'Uebertrag1000Bis999999Page',
      'SubtrahiereVertikal1000Bis999999Page',
      'UebertragSubtrahendGroesserMinuend99Bis999Page',
      'UebertrageStellenwert99Bis999Page',
      'Uebertrag99Bis999Page',
      'SubtrahiereVertikal99Bis999Page',
      'UebertragSubtrahendGroesserMinuend10Bis99Page',
      'UebertrageStellenwert10Bis99Page',
      'Uebertrag10Bis99Page',
      'SubtrahiereVertikal10Bis99Page',
      'SubtrahiereHalbschriftliche1000Bis9999Page',
      'HalbschriftlicheSubtraktion1000Bis9999Page',
      'SubtrahiereHalbschriftliche100Bis999Page',
      'HalbschriftlicheSubtraktion100Bis999Page',
      'SubtrahiereHalbschriftliche10Bis99Page',
      'HalbschriftlicheSubtraktion10Bis99Page',
      'VertikalesSubtrahierenEntbuendelnPage',
      'EntbuendelnLaufende0Page',
      'Laufende0Entbuendeln1000Bis999999Page',
      'Entbuendle1000Bis999999Page',
      'EntbuendelnSubtrahendGroesserMinuend1000Bis999999Page',
      'Entbuendeln0InMinuend1000Bis999999Page',
      'Entbuedeln1000Bis999999Page',
      'Entbuendle99Bis999Page',
      'EntbuendelnSubtrahendGroesserMinuend99Bis999Page',
      'Entbuendeln3StelligPage',
      'Entbuendeln0InMinuend99Bis999Page',
      'Entbuendle0Bis99Page',
      'EntbuendelnSubtrahendGroesserMinuend10Bis99Page',
      'Entbuendeln2Stellig10Bis99Page',
      'TestpagePage'

    ];
    return pages;
  }

  alleAdditionen(): string[] {

    let pages: string[] = [
      'ZahlenZusammenzaehlenPage',
      'VertikaleAdditionPage',
      'VertauschungsgesetzPage',
      'SummenwertGroessteZahlPage',
      'SummenwertPage',
      'SummePage',
      'SummandenPage',
      'RegelnAdditionPage',
      'RechenzeichenPlusPage',
      'NeutraleElementAdditionPage',
      'GleichheitszeichenPage',
      'DingeZusammenzaehlenPage',
      'Zehneruebergang10Bis99Page',
      'SchriftlicheAddition2StelligeZahlen10Bis99Page',
      'AdditionZehner10Bis99Page',
      'Addition2StelligeZahlenKopfrechnen10Bis99Page',
      'Addition2StelligeZahlen10Bis99Page',
      'AddiereZehneruebergang10Bis99Page',
      'AddiereZehnerEiner10Bis99Page',
      'AddiereZehner10Bis99Page',
      'AddiereSchriftlich2StelligeZahlen10Bis99Page',
      'Addiere2StelligeZahlen10Bis99Page',
      'Zahlen2Stellig10Bis19Page',
      'StellenwertEiner10Bis19Page',
      'Stellenwerk10Bis19Page',
      'SchrittweisesAddieren10Bis19Page',
      'RechnenDonuts10Bis19Page',
      'FuelleBis10Auf10Bis19Page',
      'Erste2StelligeZahl10Bis19Page',
      'AdditionenBisZehn10Bis19Page',
      'AddiereSchrittweise10Bis19Page',
      'AddiereMitChart10Bis19Page',
      'Addiere10Bis19Page',
      'FindeSumme0Bis9Page',
      'AlleAdditionen0Bis9Page',
      'AddiereSchriftlich0Bis9Page',
      'AddiereImKopf0Bis9Page',
      'UebertragPage',
      'UebertragenStellenwert1000Bis999999Page',
      'Uebertrag1000Bis999999Page',
      'AddiereVertikal1000Bis999999Page',
      'UebertragenStellenwert99Bis999Page',
      'Uebertrag99Bis999Page',
      'AddiereVertikal99Bis999Page',
      'UebertragenStellenwert10Bis99Page',
      'AddiereVertikal10Bis99Page',
      'HalbschriftlicheAddition1000Bis9999Page',
      'AddiereHalbschriftlich1000Bis9999Page',
      'HalbschriftlicheAddition100Bis999Page',
      'AddiereHalbschriftlich100bis999Page',
      'HalbschriftlicheAddition10bis99Page',
      'AddiereHalbschriftlich10bis99Page',
      'TestpagePage'

    ];
    return pages;

  }

  alleMultiplikationen(): string[] {

    let pages: string[] = [
      'MultiplikationNatuerlicherZahlenPage',
      'BestandteileMultiplikationPage',
      'MultipliziereMehrstelligeFaktorenPage',
      'MultiplikationMehrstelligeFaktorenPage',
      'MehrstelligeFaktorenPage',
      'VielfachFaktor10FachPage',
      'MultipliziereXFachPage',
      'Multipliziere10x10FachPage',
      'Multipliziere10FachPage',
      'Faktor10FachKommazahlVerschiebenPage',
      'Faktor10FachKommaVerschiebenPage',
      'Faktor10FachPage',
      'Faktor01FachKommazahlVerschiebenPage',
      'MultipliziereFaktor10EinfachPage',
      'Faktor10EinfachPage',
      'Multiplikation1StelligerFaktor2Page', 'MultipliziereEinstelligerFaktorPage',
      'FaktorMehrstelligFaktorEinstelligPage',
      'BeispielHalbschriftlicheMultiplikationPage',
      'MultipliziereEinstelligerFaktorHalbschriftlichPage',
      'Multiplikation1StelligerFaktor2HalbschriftlichPage',
      'FaktorMehrstelligFaktorEinstelligHalbschriftlichPage',
      'QuadratzahlenPage',
      'MultipliziereQuadratzahlenPage',
      'MultipliziereFaktor9Page',
      'MultipliziereFaktor8Page',
      'MultipliziereFaktor7Page',
      'MultipliziereFaktor6Page',
      'MultipliziereFaktor5Page',
      'MultipliziereFaktor4Page',
      'MultipliziereFaktor3Page',
      'MultipliziereFaktor2Page',
      'MultipliziereFaktor1Page',
      'MultipliziereFaktor0Bis9Page',
      'MultipliziereFaktor0Page',
      'Faktor9Page',
      'Faktor8Page',
      'Faktor7Page',
      'Faktor6Page',
      'Faktor5Page',
      'Faktor4Page',
      'Faktor3Page',
      'Faktor2Page',
      'Faktor1Page',
      'Faktor0Page',
      'TestpagePage'

    ];
    return pages;

  }

  alleVergleichszeichen(): string[] {

    let pages: string[] = [
      'UngleichZeichenPage',
      'UngleichGleichungPage',
      'StellenwertVergleichPage',
      'KleinerGleichZeichenPage',
      'KleinerGleichUngleichungPage',
      'KleinerAlsZeichenPage',
      'KleinerAlsUngleichungPage',
      'IstGleichZeichenPage',
      'IstGleichGleichungPage',
      'GroesserGleichZeichenPage',
      'GroesserGleichUngleichungPage',
      'GroesserAlsZeichenPage',
      'GroesserAlsUngleichungPage',
      'BestandteileUngleichungPage',
      'BestandteileGleichungPage',
      'WaehleVergleichszeichenSubtraktion1000Bis999999Page',
      'WaehleVergleichszeichenAddition1000Bis999999Page',
      'WaehleVergleichszeichen1000Bis999999Page',
      'WaehleVergleichszeichenSubtraktion0Bis999Page',
      'WaehleVergleichszeichenAddition0Bis999Page',
      'WaehleVergleichszeichen0Bis999Page',
      'WaehleVergleichszeichenSubtraktion0Bis99Page',
      'WaehleVergleichszeichenAddition0Bis99Page',
      'WaehleVergleichszeichen0Bis99Page',
      'WaehleVergleichszeichenSubtraktion0Bis19Page',
      'WaehleVergleichszeichenAddition0Bis19Page',
      'WaehleVergleichszeichen0Bis19Page',
      'WaehleVergleichszeichenSubtraktion0Bis9Page',
      'WaehleVergleichszeichenAddition0Bis9Page',
      'WaehleVergleichszeichen0Bis9Page',
      'TestpagePage'

    ];
    return pages;
  }


  alleUmstellungen(): string[] {

    let pages: string[] = [
      'GleichungsteileVertauschenSubtraktionPage',
      'GleichungsteileVertauschenAdditionPage',
      'UmstellenMitUmkehrrechnungSubtraktionPage',
      'UmkehrrechnungSubtraktionPage',
      'UmkehreSubtraktionNumber2_0Bis19Page',
      'UmkehreSubtraktionNumber1_0Bis19Page',
      'UmkehreSubtraktion0Bis19Page',
      'UmkehreSubtraktionNumber2_0Bis9Page',
      'UmkehreSubtraktionNumber1_0Bis9Page',
      'UmkehreSubtraktion0Bis9Page',
      'UmstellenMitUmkehrrechnungAdditionPage',
      'UmkehrrechnungAdditionPage',
      'RueckwaertsLesenNumber2Page',
      'RueckwaertsLesenNumber1Page',
      'UmkehreAdditionNumber2_0Bis19Page',
      'UmkehreAdditionNumber1_0Bis19Page',
      'UmkehreAddition0Bis19Page',
      'UmkehreAdditionNumber2_0Bis9Page',
      'UmkehreAdditionNumber1_0Bis9Page',
      'UmkehreAddition0Bis9Page',
      'EselbrueckeSubtraktionUnbekannteVornePage',
      'EselbrueckeSubtraktionUnbekannteMittePage',
      'BrueckeSubtraktionUnbekannteVorne0Bis19Page',
      'BrueckeSubtraktionUnbekannteMitte0Bis19Page',
      'BrueckeSubtraktionRandomNumber0Bis19Page',
      'BrueckeSubtraktionUnbekannteVorne0Bis9Page',
      'BrueckeSubtraktionUnbekannteMitte0Bis9Page',
      'BrueckeSubtraktionRandomNumber0Bis9Page',
      'EselbrueckeAdditionUnbekannteVornePage',
      'EselbrueckeAdditionUnbekannteMittePage',
      'BrueckeAdditionUnbekannteVorne0Bis19Page',
      'BrueckeAdditionUnbekannteMitte0Bis19Page',
      'BrueckeAdditionRandomNumber0Bis19Page',
      'BrueckeAdditionUnbekannteVorne0Bis9Page',
      'BrueckeAdditionUnbekannteMitte0Bis9Page',
      'BrueckeAdditionRandomNumber0Bis9Page',
      'AequivalenzumformungSubtraktionNumber2Page',
      'AequivalenzumformungSubtraktionNumber1Page',
      'UmformeSubtraktionRandomMathOperator1000Bis999999Page',
      'UmformeSubtraktionNumber2_1000Bis999999Page',
      'UmformeSubtraktionNumber1_1000Bis999999Page',
      'UmformeSubtraktionRandomMathOperator0Bis999Page',
      'UmformeSubtraktionNumber2_0Bis999Page',
      'UmformeSubtraktionNumber1_0Bis999Page',
      'UmformeSubtraktionRandomMathOperator0Bis99Page',
      'UmformeSubtraktionNumber2_0Bis99Page',
      'UmformeSubtraktionNumber1_0Bis99Page',
      'UmformeSubtraktionRandomMathOperator0Bis19Page',
      'UmformeSubtraktionNumber2_0Bis19Page',
      'UmformeSubtraktionNumber1_0Bis19Page',
      'UmformeSubtraktionNumber2_0Bis9Page',
      'UmformeSubtraktionNumber1_0Bis9Page',
      'AequivalenzumformungAdditionNumber2MitGrafikPage',
      'AequivalenzumformungAdditionNumber2Page',
      'AequivalenzumformungAdditionNumber1MitGrafikPage',
      'AequivalenzumformungAdditionNumber1Page',
      'UmformeAdditionRandomMathOperator1000Bis999999Page',
      'UmformeAdditionNumber2_1000Bis999999Page',
      'UmformeAdditionNumber1_1000Bis999999Page',
      'UmformeAdditionRandomMathOperator0Bis999Page',
      'UmformeAdditionNumber2_0Bis999Page',
      'UmformeAdditionNumber1_0Bis999Page',
      'UmformeAdditionRandomMathOperator0Bis99Page',
      'UmformeAdditionNumber2_0Bis99Page',
      'UmformeAdditionNumber1_0Bis99Page',
      'UmformeAdditionRandomMathOperator0Bis19Page',
      'UmformeAdditionNumber2_0Bis19Page',
      'UmformeAdditionNumber1_0Bis19Page',
      'UmformeAdditionNumber2_0Bis9Page',
      'UmformeAdditionNumber1_0Bis9Page',
      'TestpagePage'

    ];
    return pages;
  }

  allePunktVorStrich(): string[] {

    let pages: string[] = [
      'PunktVorStrichRegelPage',
      'PunktVorStrichBeispielePage',
      'RechnePunktVorStrich0Bis999Page',
      'RechnePunktVorStrich0Bis99Page',
      'TestpagePage'

    ];
    return pages;
  }

  alleZahlen(): string[] {

    let pages: string[] = [
      'ZiffernUndZahlenPage',
      'GeradeUndUngeradeZahlenPage',
      'ZahlenstrahlPage',
      'FindeZahlAmZahlenstrahl100000Bis1000000Page',
      'FindeZahlAmZahlenstrahl10000Bis100000Page',
      'FindeZahlAmZahlenstrahl1000Bis10000Page',
      'FindeZahlAmZahlenstrahl100Bis1000Page',
      'FindeZahlAmZahlenstrahl10Bis100Page',
      'FindeZahlAmZahlenstrahl0Bis10Page',
      'VerwandleZahlInText1000Bis999999Page',
      'VerwandleTextInZahl1000Bis999999Page',
      'TausenderZahlenPage',
      'Stellenwert1000Bis9999999Page',
      'Zahlen100Bis999Page',
      'VerwandleZahlInText100Bis999Page',
      'VerwandleTextInZahl100Bis999Page',
      'HunderterPage',
      'Zehner0Bis99Page',
      'Zahlen0Bis99Page',
      'VerwandleZahlInText19Bis99Page',
      'VerwandleTextInZahl19Bis99Page',
      'Zahlen10Bis19Page',
      'ZaehleFische0Bis19Page',
      'VerwandleZahlInText10Bis19Page',
      'VerwandleTextInZahl10Bis19Page',
      'SortiereZahlen10Bis19Page',
      'SchreibeZahlen10Bis19Page',
      'SchreibeFehlendeZahlenAufsteigend10Bis19Page',
      'SchreibeFehlendeZahlAufsteigend10Bis19Page',
      'SchreibeFehlende2ZahlenZufaelligeReihenfolge10Bis19Page',
      'Zahlen0Bis9Page',
      'ZaehleFinger0Bis9Page',
      'WaehleGeradeUngerade0Bis9Page',
      'VerwandleZahlInText0Bis9Page',
      'VerwandleTextInZahl0Bis9Page',
      'SortiereZahlenAufsteigend0Bis9Page',
      'SchreibeZahlen0Bis9Page',
      'SchreibeFehlendeZahlenAufsteigend0Bis9Page',
      'SchreibeFehlendeZahlAufsteigend0Bis9Page',
      'SchreibeFehlende2ZahlenZufaelligeReihenfolge0Bis9Page',
      'VorgaengerNachfolger100000Bis999999Page',
      'FindeVorgaengerNachfolger100000Bis999999Page',
      'VorgaengerNachfolger10000Bis99999Page',
      'FindeVorgaengerNachfolger10000Bis99999Page',
      'VorgaengerNachfolger1000Bis9999Page',
      'FindeVorgaengerNachfolger1000Bis9999Page',
      'VorgaengerNachfolger100Bis999Page',
      'FindeVorgaengerNachfolger100Bis999Page',
      'VorgaengerNachfolger10Bis99Page',
      'FindeVorgaengerNachfolger10Bis99Page',
      'VorgaengerNachfolger0Bis9Page',
      'FindeVorgaengerNachfolger0Bis9Page',
      'KaufmaennischesRundenNatuerlicheZahlenPage',
      'RundeAufZehntausender1000Bis999999Page',
      'RundeAufZehner1000Bis999999Page',
      'RundeAufTausender1000Bis999999Page',
      'RundeAufRandom1000Bis999999Page',
      'RundeAufHunderter1000Bis999999Page',
      'RundeAufZehner100Bis999Page',
      'RundeAufRandom100Bis999Page',
      'RundeAufHunderter100Bis999Page',
      'RundeAufZehner10Bis999Page',
      'StellenwertePage',
      'GanzeZahlenPage',
      'DezimalzahlenPage',
      'TestpagePage'

    ];
    return pages;
  }


}



// WEBPACK FOOTER //
// ./src/providers/kapitel/kapitel.ts